import jsonpatch from "fast-json-patch";

export const unpatch = (form, patches) => {
  const reversed = reverse(
    patches || [
      { op: "move", from: "/contact_details/home_landline", path: "/home_landline" },
      { op: "move", from: "/contact_details/home_mobile", path: "/home_mobile" },
      { op: "move", from: "/contact_details/work_email", path: "/work_email" },
      { op: "move", from: "/contact_details/home_email", path: "/home_email" },
      { op: "move", from: "/contact_details/notification_mobile", path: "/notification_mobile" },
      { op: "remove", path: "/contact_details" },
      { op: "move", from: "/security_question/question", path: "/question" },
      { op: "move", from: "/security_question/answer", path: "/answer" },
      { op: "remove", path: "/security_question" },
      { op: "move", from: "/employment_type/id", path: "/employment_type_id" },
      { op: "remove", path: "/employment_type" },
    ],
  );

  reversed.forEach(patch => {
    try {
      form = jsonpatch.applyPatch(form, [patch]).newDocument;
    } catch (e) {
      console.warn("unpatch", e.message);
    }
  });

  return form;
};

export const reverse = masterPatches => {
  let patches = JSON.parse(JSON.stringify(masterPatches));

  const reversed = [];

  for (let i = patches.length; i > 0; i--) {
    const patch = patches[i - 1];

    if (patch.op === "remove") {
      patch.op = "add";
      patch.value = {};
    }

    if (patch.op === "move") {
      const fromElement = patch.from;
      const pathElement = patch.path;

      patch.path = fromElement;
      patch.from = pathElement;
    }

    reversed.push(patch);
  }

  return reversed;
};
